<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     :selected-data="selectedPermiso" @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedPermiso" :table-columns="tableColumns" :collection-data="collectionData"
                    :auth-token="authToken" :list-api="listApi" :primaryKey="'nombre'" @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedPermiso" :load-data="loadDataPermiso"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           :primaryKey="'nombre'" @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataPermiso" :parentView="view" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import PermisosCrearActualizarComponent from "@/components/auth/components/PermisosCrearActualizarComponent";
import {useLayoutMain} from "@/layouts/main";

export default {
  name: 'PermisoCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    PermisosCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Permisos',
      entity: {gender: 'm', value: 'permiso'},
      childFormComponent: 'permisosCrearActualizarComponent',
      tableColumns: {
        "id": {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "ID",
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre",
        },
        'descripcion': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Descripción",
        },
        "menu.alias": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Menú",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        created_at: {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      },
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedPermiso = ref({
      nombre: '',
      descripcion: '',
      estado: '',
      menu_id: '',
      id : ''
    });
    const loadDataPermiso = ref({
      nombre: '',
      descripcion: '',
      menu_id: '',
      id: '',
      status : '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_PERMISO_CREATE,
      list: process.env.VUE_APP_NEST_PERMISO_FINDALL,
      update: process.env.VUE_APP_NEST_PERMISO_UPDATE,
      updateState: process.env.VUE_APP_NEST_PERMISO_UPDATESTATE
    });
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedPermiso, loadDataPermiso, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedPermiso,
      loadDataPermiso,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    };
  }
}
</script>